import styles from './user.module.scss';
import { Grid, TextField, styled, Typography, Dialog, DialogTitle, IconButton, DialogContent, DialogContentText, DialogActions } from '@mui/material';
import { useEffect, useState } from 'react';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import commonStyles from '../../../App.module.scss';
import constants from "../../../config/constants.json"
import { object, string, ref, ValidationError } from 'yup';
import dayjs from 'dayjs';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { DemoContainer } from '@mui/x-date-pickers/internals/demo';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { isEmpty, isNil } from 'lodash';
import toast from 'react-hot-toast';
import ToastSuccess from '../toast/toastSuccess';
import ToastError from '../toast/toastError';
import { apiRequest, catchErrorMessageHandler, getDevoteeId, getUserSelectedRole } from '../../../infrastructure/backendService';
import { CommonButton, CommonOutlinedButton, ContactNumberInput, CustomCalendarTodayOutlinedIcon, CustomCityStateTextField, CustomCloseIcon, CustomDatePicker, CustomInputLabel, CustomMenuItem, CustomRequiredInputLabel, StyledDateContainer } from '../StyledComponents/StyledFields';
import ToastComponent from '../toastComponent';
import deleteIcon from "../../../assets/svg/delete_outline.svg";
import updateIcon from "../../../assets/svg/update_outline.svg";
import CloseIcon from "@mui/icons-material/Close";
import apiPath from "../../../config/apiPaths.json";
import LOCALE from '../../../config/en-us.json';
import SuccessPopup from '../../devotee/donation/successPopup';
import ErrorPopup from '../ErrorPopup';
import { useParams } from 'react-router-dom';
const userName = sessionStorage.getItem('username');



interface FamilyMemberProps {
    setFamilyData: React.Dispatch<React.SetStateAction<any[]>>
    familyData: any[]
    getFamilyDetails: () => void
    id: number | null
    setShowFamilyForm: React.Dispatch<React.SetStateAction<boolean>>
    edit: boolean
    setShowFamilyAddMoreButton: React.Dispatch<React.SetStateAction<boolean>>
}

const CustomTextFeild = styled(TextField)`
//  margin-bottom:16px;
& div {
    border-radius: 8px;
}
& input {
    background-color: #fff;
    width: 370px;
    padding: 14px 16px;
    border-radius: 8px;
    height: 20px;  
   
 }
 & fieldset {
    border-style: unset;
 }
`;


const CustomSelect = styled(Select)`
& svg {
    color: #F05802;
 }
 & div {
    overflow: unset;
    padding: 14px 16px;
    height: 20px !important;
    min-height: 0px !important;
    border-radius: 8px;
    background: #fff;
    min-width: 0 !important;
 }
 & input {
    padding: 14px 16px;
    height: 20px;
    border-radius: 8px;
 }
 & fieldset {
    border-style: unset;
 }
`;


interface ErrorMessageTypes {
    firstName: string;
    middleName: string;
    lastName: string;
    dateOfBirth: string;
    relation: string;
    address: string;
    city: string;
    state: string;
    zipcode: string;
    country: string;
    email: string;
    contactNo: string;
    nakshatram: string,
    gothram: string,
}

export default function FamilyDetails(props: FamilyMemberProps) {
    const formFields = {
        firstName: '',
        middleName: '',
        lastName: '',
        dateOfBirth: '',
        relation: '',
        address: '',
        city: '',
        state: '',
        zipcode: '',
        country: '',
        contactNo: '',
        email: '',
        nakshatram: '',
        gothram: '',
    }
    const [errorMessage, setErrorMessage] = useState<ErrorMessageTypes>({ ...formFields });

    const [formData, setFormData] = useState({ ...formFields, country: "USA" });

    const [selectedId, setSelectedId] = useState<any | null | undefined>(null);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [familyMemberList, setFamilyMemberList] = useState<any[]>([]);
    const [familyData, setFamilyData] = useState<any[]>([]);
    const [getFamilyData, setGetFamilyData] = useState<any[]>([]);
    const [showEditButton, setShowEditButton] = useState<boolean>(false);
    const { userName } = useParams();
    const hasManagerLevelRole = constants.showDashBoardForRoles.includes(
        getUserSelectedRole() || ""
    );
    const finalUserName = (hasManagerLevelRole && isNil(userName)) ? getDevoteeId().userId : userName;

    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
    const validationSchema = object().shape({
        firstName: string().required('First Name is required'),
        lastName: string().required('Last Name is required'),
        // middleName: string().required('Middle Name is required'),
        dateOfBirth: string().required('DOB is required'),
        relation: string().required('Relation is required'),
        email: string()
            .required('Email is required')
            .matches(emailRegex, 'Please enter valid email address')
            .min(6, 'Email must be at least 6 characters')
            .max(64, 'Email cannot exceed 64 characters'),
        // address: string().required('Address is required'),
        country: string().required('Country is required'),
        zipcode: string().required('Zipcode is required'),
        contactNo: string()
            .required("Phone Number is required")
            .matches(/^\d{10}$/, "Phone Number should be 10 digits"),

        // gothram: string().required('Gothram is required'),
        // nakshatram: string().required('Nakshatram is required'),
    });

    const [isDatePickerOpen, setDatePickerOpen] = useState(false);

    const handleDatePickerClick = () => {
        setDatePickerOpen(true);
    };

    useEffect(() => {
        setDatePickerOpen(false);
    }, [formData.dateOfBirth]);

    const handleCancel = () => {
        getFamilyDetailsById();
    }

    const handleReset = () => {
        setFormData(formFields);
    }

    const [relationList, setRelationList] = useState<any[]>([]);

    useEffect(() => {
        apiRequest({
            method: "GET",
            endpoint: apiPath.relationsList,
            params: {
                sortBy: "id",
                page: 0,
                size: 100,
                direction: "asc",
            }
            // includeToken: true,
        })
            .then((res) => {
                setRelationList(res.data.content);
            })
            .catch((err) => {
                console.log(err, "relationnn");
                toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
                    duration: constants.TOAST_POPUP_DURATION,
                });
            });
    }, []);

    useEffect(() => {
        if (!isNil(props.id)) {
            getFamilyDetailsById()
        }
    }, [props.id])

    const getFamilyDetailsById = () => {
        apiRequest({
            method: 'GET',
            endpoint: `${apiPath.familyMemberApi}/${props.id}`,
            includeToken: true,
            params: {
                username: finalUserName
            }
        })
            .then((res) => {
                console.log(res.data, "getttt familyyyy detailssss");
                const userFromApi = res.data;
                setFormData({
                    ...formData,
                    firstName: userFromApi.firstname,
                    middleName: userFromApi.middleName,
                    lastName: userFromApi.lastname,
                    dateOfBirth: userFromApi.dateOfBirth,
                    nakshatram: userFromApi.nakshatram,
                    gothram: userFromApi.gothram,
                    address: userFromApi.address,
                    city: userFromApi.city,
                    state: userFromApi.state,
                    zipcode: userFromApi.zipcode,
                    country: userFromApi.country,
                    email: userFromApi.email,
                    contactNo: userFromApi.phoneWork,
                    relation: userFromApi.relation,
                });
                setGetFamilyData(res.data);
            })
            .catch((err) => {
                console.log(err);
                toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
                    duration: constants.TOAST_POPUP_DURATION,
                });
            });
    }

    const updateFamilyApiCall = () => {
        const reqBody = {
            firstname: formData.firstName,
            middleName: formData.middleName,
            lastname: formData.lastName,
            dateOfBirth: formData.dateOfBirth,
            relation: formData.relation,
            address: formData.address,
            city: formData.city,
            state: formData.state,
            zipcode: formData.zipcode,
            country: formData.country,
            phoneWork: formData.contactNo,
            email: formData.email,
            gothram: formData.gothram,
            nakshatram: formData.nakshatram,
            // dateOfBirth: "2023-11-01T05:50:00.788Z",
            id: props.id,
        };
        apiRequest({
            method: "PUT",
            endpoint: `${apiPath.familyDetailsUpdateApi}/${props.id}`,
            body: JSON.stringify(reqBody),
            includeToken: true,
            params: {
                username: finalUserName
            }
        })
            .then((res) => {
                const successMessage = LOCALE.DEATILS_UPDATED;
                // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
                //     duration: 10000,
                // });
                toast.custom(<SuccessPopup headerMessage="Details Update" showMessage={successMessage} isOpen={isOpen} setIsOpen={setIsOpen} />,
                    {
                        duration: constants.TOAST_POPUP_DURATION,
                    });
                console.log(res);
                props.getFamilyDetails();
                props.setShowFamilyForm(false);
                props.setShowFamilyAddMoreButton(true);
                setFormData(formFields);
            })
            .catch((err) => {
                toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
                    duration: constants.TOAST_POPUP_DURATION,
                });
                console.log(err, "edittttttttttttttttt");
            });
    };

    const saveApiCall = () => {
        const reqBody = {
            firstname: formData.firstName,
            middleName: formData.middleName,
            lastname: formData.lastName,
            dateOfBirth: formData.dateOfBirth,
            relation: formData.relation,
            address: formData.address,
            city: formData.city,
            state: formData.state,
            zipcode: formData.zipcode,
            country: formData.country,
            phoneWork: formData.contactNo,
            email: formData.email,
            gothram: formData.gothram,
            nakshatram: formData.nakshatram,
            // dateOfBirth: "2023-11-01T05:50:00.788Z",
        };
        apiRequest({
            method: 'POST',
            endpoint: apiPath.familyMemberApi,
            body: JSON.stringify(reqBody),
            includeToken: true,
            params: {
                username: finalUserName
            }
        })
            .then((res) => {
                console.log(res);
                const successMessage = LOCALE.FAMILYMEMBERS_ADDED_SUCCESS;
                // toast.custom(<ToastSuccess message={successMessage} sent={""} />, {
                //     duration: 10000
                // })
                toast.custom(<SuccessPopup headerMessage="Details Update" showMessage={successMessage} isOpen={isOpen} setIsOpen={setIsOpen} />,
                    {
                        duration: constants.TOAST_POPUP_DURATION,
                    });
                props.getFamilyDetails();
                props.setShowFamilyForm(false);
                setFormData(formFields);
            })
            .catch((err) => {
                toast.custom(<ErrorPopup showMessage={catchErrorMessageHandler(err)} isOpen={isOpen} setIsOpen={setIsOpen} />, {
                    duration: constants.TOAST_POPUP_DURATION,
                });
                console.log(err);
                // toast.error(`${err.message}`);
            });
    };

    const NakshatraList = [
        {
            label: 'Ashvini',
        },
        {
            label: 'Bharani',
        },
        {
            label: 'Krithika',
        },
        {
            label: 'Rohini',
        },
        {
            label: 'Mrigashirsha',
        },
        {
            label: 'Ardra',
        },
        {
            label: 'Punarvasu',
        },
        {
            label: 'Pushya',
        },
        {
            label: 'Ashlesha',
        },
        {
            label: 'Magha',
        },
        {
            label: 'Purva Phalguni',
        },
        {
            label: 'Uttara Phalguni',
        },
        {
            label: 'Hasta',
        },
        {
            label: 'Chitra',
        },
        {
            label: 'Swati',
        },
        {
            label: 'Vishakha',
        },
        {
            label: 'Anuradha',
        },
        {
            label: 'Jyeshtha',
        },
        {
            label: 'Mula',
        },
        {
            label: 'Purva Ashadha',
        },
        {
            label: 'Uttara Ashadha',
        },
        {
            label: 'Shravana',
        },
        {
            label: 'Dhanishtha',
        },
        {
            label: 'Shatabhisha',
        },
        {
            label: 'Purva Bhadrapada',
        },
        {
            label: 'Uttara Bhadrapada',
        },
        {
            label: 'Revati',
        },
    ];

    const gothramList = [
        {
            label: 'Paidipal',
        },
        {
            label: 'Bhrigu',
        },
        {
            label: 'Chandratre',
        },
        {
            label: 'Harinama',
        },
        {
            label: 'Audala',
        },
        {
            label: 'Agastya',
        },
    ];

    const handleFieldChange = (field: string, value: any) => {
        if (field === 'dateOfBirth' || field === 'weddinganniversary') {
            const formattedDate = dayjs(value, 'MM-DD-YYYY');

            setFormData({
                ...formData,
                [field]: formattedDate.isValid() ? formattedDate.format('MM-DD-YYYY') : '',
            });
            console.log(dayjs(value).format('MM-DD-YYYY'));
        } else {
            setFormData({
                ...formData,
                [field]: value,
            });
        }
    };

    const handleAddDetails = () => {
        const newFamilyMemberObject = {
            username: formData.firstName,
            email: formData.email,
            dateOfBirth: formData.dateOfBirth,
            relation: formData.relation,
            gothram: formData.gothram,
            nakshatram: formData.nakshatram,
        };

        setFamilyMemberList([...familyMemberList, newFamilyMemberObject]);
        // setButtonDisable(true);
    };
    console.log(familyMemberList, "newEventObjectnewEventObject");

    const handleAdd = async (): Promise<void> => {
        const errors: ErrorMessageTypes = { ...formFields };

        try {
            // Validate the form data against the validation schema
            await validationSchema.validate(formData, { abortEarly: false });
            // If validation passes, you can submit the form
            setErrorMessage(errors);
            // alert('Registration Successful');
            // Call your API or perform other actions here
            saveApiCall();
            // getFamilyDetails();
            // handleAddDetails();
            console.log("added family members data............")
            // console.log("Register Successful")
        } catch (error: any) {
            // Handle validation errors

            if (error instanceof ValidationError) {
                error.inner.forEach((e: any) => {
                    if (e.path) {
                        errors[e.path as keyof ErrorMessageTypes] = e.message;
                    }
                });
            }
            setErrorMessage(errors);
        }
    };

    const handleSave = async (): Promise<void> => {
        const errors: ErrorMessageTypes = { ...formFields };

        try {
            // Validate the form data against the validation schema
            await validationSchema.validate(formData, { abortEarly: false });
            // If validation passes, you can submit the form
            setErrorMessage(errors);
            // alert('Registration Successful');
            // Call your API or perform other actions here
            updateFamilyApiCall();
            // getFamilyDetails();
            // handleAddDetails();
            console.log("added family members data............")
            // console.log("Register Successful")
        } catch (error: any) {
            // Handle validation errors

            if (error instanceof ValidationError) {
                error.inner.forEach((e: any) => {
                    if (e.path) {
                        errors[e.path as keyof ErrorMessageTypes] = e.message;
                    }
                });
            }
            setErrorMessage(errors);
        }
    };

    const validateEmail = () => {
        const { email } = formData;

        if (email.length < 6) {
            setErrorMessage({
                ...errorMessage,
                email: "Email must be at least 6 characters long.",
            });
        } else if (email.length >= 64) {
            setErrorMessage({
                ...errorMessage,
                email: "Email must be less than 64 characters long.",
            });
        } else if (!email.includes("@")) {
            setErrorMessage({
                ...errorMessage,
                email: "Please Enter Valid Email",
            });
        } else {
            setErrorMessage({ ...errorMessage, email: "" });
        }
    };

    const handleButtons = () => {
        return (
            <div>
                {!isNil(props.id) ?
                    <>
                        <button className={commonStyles.cancelButton} onClick={handleCancel}>Reset</button>
                        <CommonButton className={commonStyles.saveButton} onClick={handleSave}>Update</CommonButton>
                    </> :
                    <>
                        <button className={commonStyles.cancelButton} onClick={handleReset}>Reset</button>
                        <CommonButton className={commonStyles.saveButton} onClick={handleAdd}>Add</CommonButton>
                    </>}
            </div>
        )
    }

    const DobDatePicker = (): React.ReactElement => {
        return (
            <div style={{ minWidth: '100%', borderRadius: "8px" }}>
                <StyledDateContainer sx={{ backgroundColor: "white", borderRadius: "8px", height: "48px" }}
                    onClick={handleDatePickerClick}
                >
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <DemoContainer components={['DateTimePicker']}>
                            <CustomDatePicker
                                open={isDatePickerOpen}
                                onClose={() => setDatePickerOpen(false)}
                                slots={{
                                    openPickerIcon: CustomCalendarTodayOutlinedIcon,
                                }}
                                slotProps={{
                                    inputAdornment: {
                                        position: 'end',
                                    },
                                }}
                                format="MM-DD-YYYY"
                                value={
                                    formData.dateOfBirth ? dayjs(formData.dateOfBirth, 'MM-DD-YYYY') : ''
                                }
                                onChange={(value) => {
                                    setErrorMessage({ ...errorMessage, dateOfBirth: '' });
                                    handleFieldChange('dateOfBirth', value);
                                }}
                                disableFuture
                                className={errorMessage.dateOfBirth ? styles.errorDateFeild : styles.dateFeildforfamily}
                            />
                        </DemoContainer>
                    </LocalizationProvider>
                    {errorMessage.dateOfBirth ? (
                        <Typography sx={{ color: 'red', fontSize: '12px' }}>
                            {errorMessage.dateOfBirth}
                        </Typography>
                    ) : (
                        ''
                    )}
                </StyledDateContainer>
            </div>
        );
    };

    const RelationDropdown = (): React.ReactElement => {
        return (
            <>
                <FormControl
                    sx={{
                        width: "100%",
                        border: "1px solid rgba(136, 46, 20, 0.40)",
                        borderRadius: "8px",
                    }}
                >
                    <CustomSelect
                        IconComponent={KeyboardArrowDownIcon}
                        defaultValue=""
                        id="grouped-select"
                        value={formData.relation}
                        onChange={(e) => {
                            setErrorMessage({ ...errorMessage, relation: '' });
                            handleFieldChange('relation', e.target.value);
                        }}
                        MenuProps={{
                            PaperProps: {
                                sx: {
                                    border: "1px solid #F05802",
                                    "& ul": {
                                        paddingTop: 0,
                                        paddingBottom: 0,
                                        overflowY: "auto",
                                        minHeight: "auto",
                                        maxHeight: "300px",
                                        "&::-webkit-scrollbar": {
                                            width: "8px",
                                        },
                                        "&::-webkit-scrollbar-thumb": {
                                            background: "#F3C539",
                                            borderRadius: "6px",
                                        },
                                    },
                                },
                            },
                        }}
                    >
                        {relationList.map((item: any, i: any) => (
                            <CustomMenuItem value={item.name} key={i}>
                                {item.name}
                            </CustomMenuItem>
                        ))}
                    </CustomSelect>
                </FormControl>
                {errorMessage.relation && (
                    <Typography sx={{ color: "red", fontSize: "12px" }}>
                        {errorMessage.relation}
                    </Typography>
                )}
            </>
        );
    };

    const nakshatramDropdown = (): React.ReactElement => {
        return (
            <FormControl className={styles.dropdownStyle} sx={{ width: "100%" }}>
                <CustomSelect
                    IconComponent={KeyboardArrowDownIcon}
                    id="grouped-select"
                    value={formData.nakshatram}
                    onChange={(e) => {
                        setErrorMessage({ ...errorMessage, nakshatram: '' });
                        handleFieldChange('nakshatram', e.target.value);
                    }}
                    className={errorMessage.nakshatram ? styles.errorTextField : ''}
                    defaultValue=""
                    MenuProps={{
                        PaperProps: {
                            sx: {
                                border: '1px solid #F05802',
                                '& ul': {
                                    paddingTop: 0,
                                    paddingBottom: 0,
                                    overflowY: 'auto',
                                    minHeight: 'auto',
                                    maxHeight: '300px',
                                    '&::-webkit-scrollbar': {
                                        width: '8px',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#F3C539',
                                        borderRadius: '6px',
                                    },
                                },
                            },
                        },
                    }}
                >
                    {NakshatraList.map((item, index: number) => (
                        <CustomMenuItem key={index} value={item.label}>
                            {item.label}
                        </CustomMenuItem>
                    ))}
                </CustomSelect>
                {!isEmpty(errorMessage.nakshatram) && (
                    <Typography sx={{ color: 'red', fontSize: '12px' }}>
                        {errorMessage.nakshatram}
                    </Typography>
                )}
            </FormControl>
        );
    };


    const zipCodeApi = () => {
        apiRequest({
            method: "GET",
            endpoint: apiPath.cityAndStateApi,
            params: {
                zip: formData.zipcode,
            },
        })
            .then((res) => {
                console.log(res.data.stateName);
                setFormData({
                    ...formData,
                    state: res.data.stateName,
                    city: res.data.city,
                });
            })
            .catch((err) => {
                console.log(err);
                setErrorMessage({
                    ...errorMessage,
                    zipcode: catchErrorMessageHandler(err),
                });
                setFormData({
                    ...formData,
                    state: "",
                    city: "",
                });
            });
    };

    const inputFields = () => {
        const handleKeyDown = (e: any, fieldName: string) => {
            // Prevent entering numeric characters
            if ((e.key >= '0' && e.key <= '9') || /[!@#$%^&*()_+{}\[\]:;<>,.?~\\/-=`|"]/.test(e.key)) {
                e.preventDefault();
            }
        };

        const handleCloseForm = () => {
            props.setShowFamilyForm(false);
            props.setShowFamilyAddMoreButton(true);
        }


        return (
            <div className={styles.formContainer}>
                <div style={{ float: "right" }} onClick={handleCloseForm}>
                    <CustomCloseIcon />
                </div>
                <Grid container spacing={2}>
                    <Grid xs={12} sm={3} item>
                        {CustomRequiredInputLabel("First Name", true)}
                        <CustomTextFeild
                            fullWidth
                            required
                            value={formData.firstName}
                            onChange={(e: any) => {
                                const inputValue = e.target.value;
                                if (inputValue.length <= 50) {
                                    setErrorMessage({ ...errorMessage, firstName: "" });
                                    handleFieldChange("firstName", inputValue);
                                } else {
                                    setErrorMessage({
                                        ...errorMessage,
                                        firstName: "Maximum allowed characters is 50.",
                                    });
                                }
                            }}
                            className={errorMessage.firstName ? styles.errorTextField : styles.textField}
                            onKeyDown={(e) => handleKeyDown(e, "firstName")}
                            placeholder="Enter Firstname"
                        />
                        {errorMessage.firstName && (
                            <Typography sx={{ color: 'red', fontSize: '12px' }}>
                                {errorMessage.firstName}
                            </Typography>
                        )}
                    </Grid>
                    <Grid xs={12} sm={3} item >
                        <CustomInputLabel>Middle Name</CustomInputLabel>
                        <CustomTextFeild
                            fullWidth
                            required
                            value={formData.middleName}
                            onChange={(e: any) => {
                                const inputValue = e.target.value;
                                if (inputValue.length <= 50) {
                                    setErrorMessage({ ...errorMessage, middleName: "" });
                                    handleFieldChange("middleName", inputValue);
                                } else {
                                    setErrorMessage({
                                        ...errorMessage,
                                        middleName: "Maximum allowed characters is 50.",
                                    });
                                }
                            }}
                            onKeyDown={(e) => handleKeyDown(e, "middleName")}
                            className={errorMessage.middleName ? styles.errorTextField : styles.textField}
                            placeholder="Enter Middlename"
                        />
                        {errorMessage.middleName && (
                            <Typography sx={{ color: 'red', fontSize: '12px' }}>
                                {errorMessage.middleName}
                            </Typography>
                        )}
                    </Grid>
                    <Grid xs={12} sm={3} item>
                        {CustomRequiredInputLabel("Last Name", true)}
                        <CustomTextFeild
                            fullWidth
                            required
                            value={formData.lastName}
                            onChange={(e: any) => {
                                const inputValue = e.target.value;
                                if (inputValue.length <= 50) {
                                    setErrorMessage({ ...errorMessage, lastName: "" });
                                    handleFieldChange("lastName", inputValue);
                                } else {
                                    setErrorMessage({
                                        ...errorMessage,
                                        lastName: "Maximum allowed characters is 50.",
                                    });
                                }
                            }}
                            onKeyDown={(e) => handleKeyDown(e, "lastName")}
                            className={errorMessage.lastName ? styles.errorTextField : styles.textField}
                            placeholder="Enter Lastname"
                        />
                        {errorMessage.lastName && (
                            <Typography sx={{ color: 'red', fontSize: '12px' }}>
                                {errorMessage.lastName}
                            </Typography>
                        )}
                    </Grid>
                </Grid>
                <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                    <Grid item xs={12} sm={3}>
                        {CustomRequiredInputLabel("DOB", true)}
                        {DobDatePicker()}
                    </Grid>
                    <Grid xs={12} sm={3} item>
                        {CustomRequiredInputLabel("Relation", true)}
                        {RelationDropdown()}
                    </Grid>
                    {/* <Grid item xs={12} sm={3}>
                        {CustomRequiredInputLabel("Relation", true)}
                        <CustomTextFeild
                            fullWidth
                            required
                            value={formData.relation}
                            onChange={(e) => {
                                setErrorMessage({ ...errorMessage, relation: '' });
                                handleFieldChange('relation', e.target.value);
                            }}
                            className={errorMessage.relation ? styles.errorTextField : styles.textField}
                        />
                        {errorMessage.relation && (
                            <Typography sx={{ color: 'red', fontSize: '12px' }}>
                                {errorMessage.relation}
                            </Typography>
                        )}
                    </Grid> */}
                </Grid>
                <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                    <Grid item xs={12} sm={3}>
                        {CustomRequiredInputLabel("Zip Code", true)}
                        <CustomTextFeild
                            fullWidth
                            required
                            value={formData.zipcode}
                            onChange={(e) => {
                                const inputValue = e.target.value;
                                // Only allow numbers
                                const sanitizedInput = inputValue
                                    .replace(/[^0-9]/g, "")
                                    .slice(0, 10);
                                setErrorMessage({ ...errorMessage, zipcode: '' });
                                handleFieldChange("zipcode", sanitizedInput);
                            }}
                            onBlur={zipCodeApi}
                            className={errorMessage.zipcode ? styles.errorTextField : styles.textField}
                            placeholder="Enter Zipcode"
                        />
                        {errorMessage.zipcode && (
                            <Typography sx={{ color: 'red', fontSize: '12px' }}>
                                {errorMessage.zipcode}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        {CustomRequiredInputLabel("City", true)}
                        <CustomTextFeild
                            fullWidth
                            required
                            value={formData.city}
                            InputProps={{
                                readOnly: true,
                            }}
                            onChange={(e) => {
                                setErrorMessage({ ...errorMessage, city: '' });
                                handleFieldChange('city', e.target.value);
                            }}
                            className={errorMessage.city ? styles.errorTextField : styles.textField}
                        />
                        {errorMessage.city && (
                            <Typography sx={{ color: 'red', fontSize: '12px' }}>
                                {errorMessage.city}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        {CustomRequiredInputLabel("State", true)}
                        <CustomTextFeild
                            fullWidth
                            required
                            value={formData.state}
                            InputProps={{
                                readOnly: true,
                            }}
                            onChange={(e) => {
                                setErrorMessage({ ...errorMessage, state: '' });
                                handleFieldChange('state', e.target.value);
                            }}
                            className={errorMessage.state ? styles.errorTextField : styles.textField}
                        />
                        {errorMessage.state && (
                            <Typography sx={{ color: 'red', fontSize: '12px' }}>
                                {errorMessage.state}
                            </Typography>
                        )}
                    </Grid>

                </Grid>
                <Grid container spacing={2} sx={{ marginTop: '0px' }}>
                    <Grid item xs={12} sm={3}>
                        {CustomRequiredInputLabel("Country", true)}
                        <CustomTextFeild
                            fullWidth
                            required
                            value={formData.country}
                            onChange={(e) => {
                                setErrorMessage({ ...errorMessage, country: '' });
                                handleFieldChange('country', e.target.value);
                            }}
                            className={errorMessage.country ? styles.errorTextField : styles.textField}
                        />
                        {errorMessage.country && (
                            <Typography sx={{ color: 'red', fontSize: '12px' }}>
                                {errorMessage.country}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        {CustomRequiredInputLabel("Address", false)}
                        <CustomTextFeild
                            fullWidth
                            required
                            value={formData.address}
                            onChange={(e: any) => {
                                const inputValue = e.target.value;
                                if (inputValue.length <= 100) {
                                    setErrorMessage({ ...errorMessage, address: "" });
                                    handleFieldChange("address", inputValue);
                                } else {
                                    setErrorMessage({
                                        ...errorMessage,
                                        address: "Address cannot exceed 100 characters",
                                    });
                                }
                            }}
                            className={errorMessage.address ? styles.errorTextField : styles.textField}
                            placeholder="Enter Address"
                        />
                        {errorMessage.address && (
                            <Typography sx={{ color: 'red', fontSize: '12px' }}>
                                {errorMessage.address}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={3}>
                        {CustomRequiredInputLabel("Contact No", true)}
                        <CustomTextFeild
                            fullWidth
                            type="tel"
                            required
                            value={formData.contactNo}
                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                                const inputNumber = e.target.value.replace(/\D/g, ''); // Remove non-numeric characters
                                const slicedNumber = inputNumber.slice(0, 10); // Limit to 10 digits
                                setErrorMessage({ ...errorMessage, contactNo: '' });
                                handleFieldChange('contactNo', slicedNumber);
                            }}
                            className={errorMessage.contactNo ? styles.errorConatctFeilds : styles.textField}
                            placeholder="Enter Phone number"
                        />
                        {errorMessage.contactNo && (
                            <Typography sx={{ color: 'red', fontSize: '12px' }}>
                                {errorMessage.contactNo}
                            </Typography>
                        )}
                    </Grid>
                </Grid>

                <Grid container spacing={2} sx={{ marginTop: '0px' }}>

                    <Grid item xs={12} sm={3}>
                        {CustomRequiredInputLabel("Email", true)}
                        <CustomTextFeild
                            fullWidth
                            required
                            value={formData.email}
                            onChange={(e) => {
                                setErrorMessage({ ...errorMessage, email: '' });
                                handleFieldChange('email', e.target.value);
                            }}
                            onBlur={validateEmail}
                            className={errorMessage.email ? styles.errorTextField : styles.textField}
                            placeholder="Enter Email"
                        />
                        {errorMessage.email && (
                            <Typography sx={{ color: 'red', fontSize: '12px' }}>
                                {errorMessage.email}
                            </Typography>
                        )}
                    </Grid>
                    <Grid item xs={12} sm={3} >
                        <CustomInputLabel>Nakshatram</CustomInputLabel>
                        {nakshatramDropdown()}
                    </Grid>
                    <Grid item xs={12} sm={3} >
                        <CustomInputLabel>Gothram</CustomInputLabel>
                        <CustomTextFeild
                            sx={{ border: "1px solid rgba(136, 46, 20, 0.40)", borderRadius: "8px" }}
                            className={styles.textField}
                            fullWidth
                            required
                            value={formData.gothram}
                            onChange={(e: any) => {
                                const inputValue = e.target.value;
                                if (inputValue.length <= 25) {
                                    setErrorMessage({ ...errorMessage, gothram: "" });
                                    handleFieldChange("gothram", inputValue);
                                } else {
                                    setErrorMessage({
                                        ...errorMessage,
                                        gothram: "Gothram cannot exceed 25 characters",
                                    });
                                }
                            }}
                            placeholder="Enter Gothram"
                        />
                        {errorMessage.gothram && (
                            <Typography sx={{ color: 'red', fontSize: '12px' }}>
                                {errorMessage.gothram}
                            </Typography>
                        )}
                    </Grid>
                    <div className={styles.addResetButtons}>
                        {handleButtons()}
                    </div>
                </Grid>

            </div>
        )
    }


    return (
        <div className={styles.BoxContainer}>
            <ToastComponent />
            {inputFields()}
        </div>
    )
}